var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal-fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "hotkey",
            rawName: "v-hotkey",
            value: _vm.keymap,
            expression: "keymap",
          },
        ],
        staticClass: "c-modal c-modal--figure",
        attrs: { role: "dialog" },
        on: {
          click: function ($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            !_vm.$emit("close")
          },
        },
      },
      [
        _c(
          "button",
          {
            staticClass: "c-modal__close",
            attrs: { type: "button", "aria-label": "Lukk", tabindex: "1" },
            on: {
              click: function ($event) {
                !_vm.$emit("close")
              },
            },
          },
          [_c("icon-close", { staticClass: "c-icon--negative" })],
          1
        ),
        _vm._v(" "),
        _vm._t("default"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }